export default __webpack_public_path__ + "static/media/placas-solares.0ce9f66c.jpg";